import NewCairoHeroImage from "../NewCairoHeroImage/NewCairoHeroImage";

export default function PageHeroImage() {
  return <NewCairoHeroImage />;
}
